import { LoanConfigWithGuaranteeIdsDto } from "api/borrower"
import { MainBorrowerPricingState } from "../../types"

export interface TogglePsyBuybackParams {
  loanId: string
}

export const togglePsyBuyback = (
  params: TogglePsyBuybackParams,
  onSearch: (loans: LoanConfigWithGuaranteeIdsDto[]) => void,
  getState: () => MainBorrowerPricingState
): void => {
  const { loanId } = params
  const state = getState()
  const { pendingLoanConfigs } = state

  const currentPendingLoan = pendingLoanConfigs.find(loan => loan.loanId === loanId)
  if (!currentPendingLoan) return

  const updatedConfigs = pendingLoanConfigs.map(config => {
    if (config.loanId === loanId) {
      return {
        ...config,
        isPsyBuyback: !config.isPsyBuyback
      }
    }
    return config
  })

  onSearch(updatedConfigs)
}
